import { builder } from './builder';
import { units } from './constants';

export const recommendedLinksConfig = builder.holder({
  hasImage: builder.exists('recommended_links_image', {
    defaultValue: false
  }),
  useRecommendedLinks: builder.boolean('use_recommended_links', {
    defaultValue: false,
    label: 'Enable recommended links',
    description:
      'Display a recommended links when the user close the Ogury browser'
  }),
  imageUrl: builder.string('recommended_links_image', {
    label: 'Image',
    description: 'Image of the recommended links',
    overrideType: 'image',
    if: 'use_recommended_links'
  }),
  title: builder.string('recommended_links_title', {
    label: 'Title',
    description: 'Title of the recommended links',
    if: 'use_recommended_links'
  }),
  text: builder.string('recommended_links_text', {
    label: 'Text',
    description: 'Text of the recommended links',
    if: 'use_recommended_links'
  }),
  noBounceUrl: builder.string('recommended_links_nobounce', {
    label: 'Target Url',
    description:
      'Url of the page where the user will be redirect on click on the recommended links',
    if: 'use_recommended_links'
  }),
  autoCloseDuration: builder.number('recommended_links_acd', {
    optional: true,
    // Warning if you change the default value, it is also set in a getParameter function in browser-sdk3/index.js
    defaultValue: 5,
    label: 'Autoclose duration',
    description: 'Autoclose duration in second of the recommended links',
    if: 'use_recommended_links',
    unit: units.seconds
  }),
  displayCloseButton: builder.boolean(
    'recommended_links_display_close_button',
    {
      // Warning if you change the default value, this parameter is forced to be true in browser-sdk3/index.js
      defaultValue: true,
      label: 'Display Close Button',
      description: 'Display close button or not',
      if: 'use_recommended_links'
    }
  ),
  useLoader: builder.boolean('recommended_links_use_loader', {
    label: 'Display loader on click',
    defaultValue: false,
    description:
      'When the user clicks on the reco links, we display a fullscreen loader component'
  }),
  redirectUrl: builder.string('recommended_links_redirect_url', {
    label: 'Redirect URL before nobounce',
    defaultValue: '',
    description: 'Redirect to this page before redirect to nobounce url'
  }),
  loaderTimeout: builder.number('recommended_links_loader_timeout', {
    label: 'Duration before closing the loader (in seconds)',
    defaultValue: 5,
    description: 'Maximum display time of the loader',
    unit: units.seconds
  }),
  loaderCloseUrlRegex: builder.string(
    'recommended_links_loader_close_url_regex',
    {
      label: "Regex of the url that close the loader (defaultValue: '')",
      defaultValue: '',
      description:
        'Regex of the url that close the loader: when a page is loaded in the browser and matchs this regex, the loader is automatically closed'
    }
  ),
  loaderImage: builder.string('recommended_links_loader_image', {
    label: 'Loader image',
    defaultValue: '',
    description: 'Loader image'
  }),
  loaderColor: builder.string('recommended_links_loader_color', {
    label: 'Loader color',
    defaultValue: '#ef3834',
    description: 'Loader color'
  }),
  triggerUrlRegex: builder.string('recommended_links_trigger_url_regex', {
    label: 'Trigger URL regex',
    defaultValue: ''
  }),
  useFullscreen: builder.boolean('recommended_links_use_fullscreen', {
    label: 'Fullscreen Enabled',
    defaultValue: false
  }),
  closeBtnSize: builder.number('recommended_links_close_btn_size', {
    label: 'Close button size',
    defaultValue: 20,
    unit: units.pixel
  }),
  closeBtnColor: builder.string('recommended_links_close_btn_color', {
    label: 'Close btn color',
    defaultValue: '#575757'
  }),
  progressbarColor: builder.string('recommended_links_progressbar_color', {
    label: 'Progress bar color',
    defaultValue: '#FFF'
  }),
  customTranslations: builder.object('recommended_links_translations', {
    defaultValue: {},
    description: `Custom translations in JSON format.<br>Overridable fields: \`title\` and \`ok_button\`<br>ex: \`{"en": {"ok_button": "OK"}}\``
  })
});
